module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921011151_T.c3134789.jpg";